import React, {useState} from "react";
import axios from 'axios';
import { Action, Store } from "@byhuz/huz-ui-state";

// components

import CardHistory from "components/Cards/CardHistory.js";

export default function History() {

  const [token, setToken] = useState(null);

  React.useEffect(()=>{

    const getHistory = () => {
      axios.get('tokenhistory')
      .then(res=>{
        if (parseInt(res.data.code)===400) {          
          Store.dispatch(Action.update("loggedIn", false));
          Store.dispatch(Action.update("user"));
          return;
        }

        if (parseInt(res.data.code)===404) {            
            Store.dispatch(Action.update("loggedIn", false));
            Store.dispatch(Action.update("user"));
            return;
        }

        if (parseInt(res.data.code)===200) {            
          setToken (res.data.payload.history);
        }
      })
      .catch(err=>{
        console.log(err);
        Store.dispatch(Action.update("loggedIn", false));
        Store.dispatch(Action.update("user"));
        return;
      });  
    }
    getHistory();

  },[]);
  
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <CardHistory color="dark" token={token}/>
        </div>
      </div>
    </>
  );
}
